var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSewing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 26,
    viewBox: "0 0 35 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.09632 0.786164H31.7833C32.5814 0.786164 33.2347 1.43911 33.2347 2.23731V7.07499C33.2347 7.87318 32.5814 8.52639 31.7833 8.52639H9.62716L7.5349 14.1259C7.24459 14.8756 6.88185 15.577 6.07142 15.577H3.09632C2.29818 15.577 1.64502 14.9241 1.64502 14.1259C1.64502 10.1589 1.64502 6.19191 1.64502 2.23731C1.64502 1.43911 2.29818 0.786164 3.09632 0.786164Z",
    fill: "#10B2BD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.09632 0.786195H31.7833C32.5814 0.786195 33.2347 1.43914 33.2347 2.23734V5.45437C32.9805 5.90197 32.4968 6.21619 31.9528 6.21619H2.92704C2.37073 6.21619 1.88704 5.90197 1.64502 5.45437V2.23734C1.64502 1.43914 2.29818 0.786195 3.09632 0.786195Z",
    fill: "#53D5DC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7828 8.52639H19.314V21.9022H31.7828V8.52639Z",
    fill: "#10B2BD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7828 8.5264H19.314V14.2709C20.1848 11.1023 23.8251 9.11872 31.7828 8.96188V8.5264Z",
    fill: "#10C2D0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5208 23.8616H0.822266V22.3013C0.822266 22.0835 1.00373 21.9022 1.22142 21.9022H32.1217C32.3394 21.9022 32.5208 22.0835 32.5208 22.3013V23.8616Z",
    fill: "#5D757E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 23.8615H33.3433V25.8328H0V23.8615Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.02686 15.5771H4.92182V18.4193L4.02686 20.3541V15.5771Z",
    fill: "#626D70"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.92236 16.7622H5.91418V17.2944H4.92236V16.7622Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.24048 16.1214C6.05912 16.1214 5.91406 16.2667 5.91406 16.4359V17.6211C5.91406 17.8024 6.05912 17.9355 6.24048 17.9355C6.40974 17.9355 6.55491 17.8024 6.55491 17.6211V16.4359C6.55491 16.2667 6.40974 16.1214 6.24048 16.1214Z",
    fill: "#5D757E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2344 3.79755H33.6456V5.50281H33.2344V3.79755Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6008 2.51571H34.0325C33.8269 2.51571 33.6455 2.69707 33.6455 2.91454V6.39781C33.6455 6.61555 33.8269 6.78479 34.0325 6.78479H34.6008C34.8185 6.78479 34.9999 6.61555 34.9999 6.39781V2.91454C34.9999 2.69707 34.8185 2.51571 34.6008 2.51571Z",
    fill: "#5D757E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5982 0.786133H18.2495V0.290295C18.2495 0.13292 18.3826 6.62208e-05 18.5397 6.62208e-05H27.3079C27.465 6.62208e-05 27.5982 0.13292 27.5982 0.290295V0.786133Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6363 2.60021H27.9978C28.2759 2.60021 28.5057 2.83008 28.5057 3.10818V4.05136C28.5057 4.34158 28.2759 4.55933 27.9978 4.55933H21.6363C21.3581 4.55933 21.1284 4.34158 21.1284 4.05136V3.10818C21.1284 2.83008 21.3581 2.60021 21.6363 2.60021Z",
    fill: "#10888D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3614 12.4447H28.723C28.9405 12.4447 29.11 12.6142 29.11 12.8198V20.0399C29.11 20.2576 28.9405 20.4269 28.723 20.4269H22.3614C22.1437 20.4269 21.9746 20.2576 21.9746 20.0399V12.8198C21.9746 12.6142 22.1437 12.4447 22.3614 12.4447Z",
    fill: "#10888D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.906 13.1339H28.191C28.2877 13.1339 28.3605 13.2067 28.3605 13.3034V15.4924C28.3605 15.5891 28.2877 15.6616 28.191 15.6616H22.906C22.8092 15.6616 22.7246 15.5891 22.7246 15.4924V13.3034C22.7246 13.2067 22.8092 13.1339 22.906 13.1339Z",
    fill: "#0E6563"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6797 13.1339H28.1908C28.2875 13.1339 28.3603 13.2067 28.3603 13.3034V15.4924C28.3603 15.5891 28.2875 15.6616 28.1908 15.6616H26.6429C24.5746 15.0933 23.8732 13.6904 23.6797 13.1339Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2159 18.1771C24.9375 18.1771 24.6594 18.1771 24.3692 18.1771C24.3088 18.1771 24.2725 18.2256 24.2725 18.286C24.2725 18.5641 24.2725 18.8543 24.2725 19.1327C24.2725 19.1931 24.3088 19.2416 24.3692 19.2416C24.6594 19.2416 24.9375 19.2416 25.2159 19.2416C25.2763 19.2416 25.3248 19.1931 25.3248 19.1327C25.3248 18.8543 25.3248 18.5641 25.3248 18.286C25.3248 18.2256 25.2763 18.1771 25.2159 18.1771Z",
    fill: "#B6CFD5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7164 16.5205H22.8697C22.8093 16.5205 22.7729 16.569 22.7729 16.6293V17.4636C22.7729 17.5243 22.8093 17.5725 22.8697 17.5725H23.7164C23.7768 17.5725 23.8253 17.5243 23.8253 17.4636V16.6293C23.8253 16.569 23.7768 16.5205 23.7164 16.5205Z",
    fill: "#B6CFD5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2159 16.5205C24.9375 16.5205 24.6594 16.5205 24.3692 16.5205C24.3088 16.5205 24.2725 16.569 24.2725 16.6293C24.2725 16.9074 24.2725 17.1855 24.2725 17.4636C24.2725 17.5243 24.3088 17.5725 24.3692 17.5725C24.6594 17.5725 24.9375 17.5725 25.2159 17.5725C25.2763 17.5725 25.3248 17.5243 25.3248 17.4636C25.3248 17.1855 25.3248 16.9074 25.3248 16.6293C25.3248 16.569 25.2763 16.5205 25.2159 16.5205Z",
    fill: "#B6CFD5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7164 18.1771H22.8697C22.8093 18.1771 22.7729 18.2256 22.7729 18.286V19.1327C22.7729 19.1931 22.8093 19.2416 22.8697 19.2416H23.7164C23.7768 19.2416 23.8253 19.1931 23.8253 19.1327V18.286C23.8253 18.2256 23.7768 18.1771 23.7164 18.1771Z",
    fill: "#B6CFD5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7159 18.1771C26.4378 18.1771 26.1597 18.1771 25.8692 18.1771C25.821 18.1771 25.7725 18.2256 25.7725 18.286C25.7725 18.5641 25.7725 18.8543 25.7725 19.1327C25.7725 19.1931 25.821 19.2416 25.8692 19.2416C26.1597 19.2416 26.4378 19.2416 26.7159 19.2416C26.7763 19.2416 26.8248 19.1931 26.8248 19.1327C26.8248 18.8543 26.8248 18.5641 26.8248 18.286C26.8248 18.2256 26.7763 18.1771 26.7159 18.1771Z",
    fill: "#B6CFD5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2151 16.5205H27.3684C27.3202 16.5205 27.272 16.569 27.272 16.6293V17.4636C27.272 17.5243 27.3202 17.5725 27.3684 17.5725H28.2151C28.2755 17.5725 28.324 17.5243 28.324 17.4636V16.6293C28.324 16.569 28.2755 16.5205 28.2151 16.5205Z",
    fill: "#B6CFD5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2151 18.1771H27.3684C27.3202 18.1771 27.272 18.2256 27.272 18.286V19.1327C27.272 19.1931 27.3202 19.2416 27.3684 19.2416H28.2151C28.2755 19.2416 28.324 19.1931 28.324 19.1327V18.286C28.324 18.2256 28.2755 18.1771 28.2151 18.1771Z",
    fill: "#B6CFD5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7159 16.5205C26.4378 16.5205 26.1597 16.5205 25.8692 16.5205C25.821 16.5205 25.7725 16.569 25.7725 16.6293C25.7725 16.9074 25.7725 17.1855 25.7725 17.4636C25.7725 17.5243 25.821 17.5725 25.8692 17.5725C26.1597 17.5725 26.4378 17.5725 26.7159 17.5725C26.7763 17.5725 26.8248 17.5243 26.8248 17.4636C26.8248 17.1855 26.8248 16.9074 26.8248 16.6293C26.8248 16.569 26.7763 16.5205 26.7159 16.5205Z",
    fill: "#B6CFD5"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.14005 11.4411C5.95029 11.4411 6.60346 12.1061 6.60346 12.9165C6.60346 13.7268 5.95029 14.3918 5.14005 14.3918C4.31763 14.3918 3.66455 13.7268 3.66455 12.9165C3.66455 12.1061 4.31763 11.4411 5.14005 11.4411Z",
    fill: "#10888D"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.13976 12.2635C5.50262 12.2635 5.79284 12.5538 5.79284 12.9165C5.79284 13.2792 5.50262 13.5815 5.13976 13.5815C4.76481 13.5815 4.47461 13.2792 4.47461 12.9165C4.47461 12.5538 4.76481 12.2635 5.13976 12.2635Z",
    fill: "#10C2D0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.02686 15.577H4.92182V16.2059H4.02686V15.577Z",
    fill: "#2C3334"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.566 6.78481H16.0248C16.3391 6.78481 16.5932 7.03865 16.5932 7.35314C16.5932 7.66762 16.3391 7.93359 16.0248 7.93359H12.566C12.2515 7.93359 11.9976 7.66762 11.9976 7.35314C11.9976 7.03865 12.2515 6.78481 12.566 6.78481Z",
    fill: "#B4EDEF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6383 7.06285C12.4691 7.06285 12.3481 7.19598 12.3481 7.35308C12.3481 7.51046 12.4691 7.64331 12.6383 7.64331C12.7956 7.64331 12.9166 7.51046 12.9166 7.35308C12.9166 7.19598 12.7956 7.06285 12.6383 7.06285Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7389 7.06285C13.5817 7.06285 13.4487 7.19598 13.4487 7.35308C13.4487 7.51046 13.5817 7.64331 13.7389 7.64331C13.8962 7.64331 14.0292 7.51046 14.0292 7.35308C14.0292 7.19598 13.8962 7.06285 13.7389 7.06285Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8512 7.06285C14.694 7.06285 14.561 7.19598 14.561 7.35308C14.561 7.51046 14.694 7.64331 14.8512 7.64331C15.0085 7.64331 15.1294 7.51046 15.1294 7.35308C15.1294 7.19598 15.0085 7.06285 14.8512 7.06285Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9519 7.06285C15.7948 7.06285 15.6738 7.19598 15.6738 7.35308C15.6738 7.51046 15.7948 7.64331 15.9519 7.64331C16.1092 7.64331 16.2422 7.51046 16.2422 7.35308C16.2422 7.19598 16.1092 7.06285 15.9519 7.06285Z",
    fill: "black",
    fillOpacity: 0.87
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSewing);
export default __webpack_public_path__ + "static/media/sewing.e2f49d6e112d24564efcba0df85312fc.svg";
export { ForwardRef as ReactComponent };